import { useTranslation } from 'react-i18next';
import { LoadingShell } from '@/components/loading/LoadingShell';
import { TypewriterLine } from '@/components/loading/TypewriterLine';

interface AppLoadingScreenProps {
  message?: string;
}

/**
 * Full-screen auth-boot loader: org logo + sliding bar + the CURRENT boot
 * phase typed once, then held with a blinking caret. The phase messages from
 * ProtectedRoute (authenticating → locations → profile) are real state
 * reports, so they never rotate; a phase change backspaces and retypes.
 */
export default function AppLoadingScreen({ message }: AppLoadingScreenProps) {
  const { t } = useTranslation('common');
  const displayMessage = message ?? t('loading');

  return (
    <LoadingShell fullScreen>
      <TypewriterLine messages={[displayMessage]} />
    </LoadingShell>
  );
}
